var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* istanbul ignore file */
// all requires actual browser
import { Editor, Element as SlateElement, Node, Range, Transforms, Point, Path, } from "slate";
import isUrl from "is-url";
import { ElementType } from "../types";
// support inline buttons and links for editing after transformations
export var withInlines = function (editor) {
    var insertData = editor.insertData, insertText = editor.insertText, isInline = editor.isInline;
    editor.isInline = function (element) {
        return ["link", "button"].includes(element.type) || isInline(element);
    };
    editor.insertText = function (text) {
        if (text && isUrl(text)) {
            wrapLink(editor, text);
        }
        else {
            insertText(text);
        }
    };
    editor.insertData = function (data) {
        var text = data.getData("text/plain");
        if (text && isUrl(text)) {
            wrapLink(editor, text);
        }
        else {
            insertData(data);
        }
    };
    return editor;
};
/**
 * remove link from text
 */
export var unwrapLink = function (editor) {
    Transforms.unwrapNodes(editor, {
        match: function (n) {
            return !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === "link";
        },
    });
};
/**
 * get text and link of current selection
 */
export var getLinkSelectionData = function (editor) {
    var _a, _b;
    var selection = editor.selection;
    var fragment = editor.getFragment();
    // collapsed means no text is highlighted
    var isCollapsed = selection && Range.isCollapsed(selection);
    var text = "";
    var link = "";
    // get text at selection position
    if (selection && !isCollapsed) {
        text = Editor.string(editor, selection);
    }
    // search fragment that text his highlighting OR cursor is att
    var arr = Array.from(Node.elements(fragment[0]));
    // filter out all items at fragment that are links
    var answer = arr.filter(function (_a) {
        var _b = __read(_a, 2), elem = _b[0], _path = _b[1];
        return elem.type === ElementType.Link;
    });
    // if exactly 1 link is found return that link, otherwise dont return any link
    if (answer.length === 1) {
        link = ((_b = (_a = answer[0]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.link) || "";
    }
    return {
        text: text,
        link: link,
    };
};
/**
 * wrap text in a link with supplied text
 */
export var wrapLink = function (editor, link, text) {
    if (link === void 0) { link = ""; }
    if (isLinkActive(editor)) {
        unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && Range.isCollapsed(selection);
    // link element to create
    var linkElement = {
        type: ElementType.Link,
        link: link,
        children: [{ text: text || link }],
    };
    if (!link && text) {
        if (isCollapsed) {
            Transforms.insertText(editor, text);
        }
        else if (selection) {
            Transforms.insertText(editor, text, {
                at: selection,
            });
            // if collapsed insert node inline between whatever text cursor is at
        }
    }
    else if (isCollapsed) {
        Transforms.insertNodes(editor, linkElement);
        // move to end of link and add space
        var nextPoint = Editor.after(editor, editor.selection);
        var endPointOfEditor = Editor.end(editor, []);
        var isLinkAtEndOfEditor = Point.equals(nextPoint, endPointOfEditor);
        if (isLinkAtEndOfEditor) {
            Transforms.select(editor, endPointOfEditor);
            Transforms.insertText(editor, " ");
        }
        // if not collapsed then insert on top of selection
    }
    else if (selection) {
        Transforms.insertNodes(editor, linkElement, {
            at: selection,
        });
        // collapse selection afterwords
        if (!isCollapsed) {
            Transforms.collapse(editor, { edge: "end" });
        }
        // move to end of link and add space
        var nextPoint = Editor.after(editor, editor.selection);
        var endPointOfEditor = Editor.end(editor, []);
        var beforeEndPointOfEditor = Editor.before(editor, endPointOfEditor);
        var isLinkAtEndOfEditor = Path.equals(nextPoint.path, beforeEndPointOfEditor.path);
        if (isLinkAtEndOfEditor) {
            Transforms.select(editor, endPointOfEditor);
            Transforms.insertText(editor, " ");
        }
    }
};
/**
 * ensures a selection exists before attempting to wrap a link
 */
export var insertLink = function (editor, link, text) {
    if (editor.selection) {
        wrapLink(editor, link, text);
    }
};
/**
 * check if link icon should be active
 */
export var isLinkActive = function (editor) {
    var _a = __read(Editor.nodes(editor, {
        match: function (n) {
            return !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === "link";
        },
    }), 1), link = _a[0];
    return !!link;
};
